<template>
  <div class="layout-form">
    <joi-form :data="data" :schema="validationSchema" :error="formError" v-on:formdataready="save">
      <div class="row">
        <div class="small-4 columns small-centered">
          <span data-form-error-callout></span>
        </div>
      </div>

      <div class="row expanded" v-if="data.id">
        <div class="small-12 medium-4 columns">
          <label>Utolsó beolvasás:</label>
          <div class="displayfield">
            {{lastReadingInf}}<br>
            <button type="button" class="button tiny primary trans-uppercase" v-if="data.id" @click="download">Letöltés</button>
          </div>
        </div>
      </div>

      <div class="row expanded" av-if="data.rssUrl">
        <div class="small-12 columns">
          <label style="padding-bottom: 10px">
            RSS URL: <br>
            <a :href="data.rssUrl" target="_blank">{{data.rssUrl}}</a>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Megnevezés:
            <input type="text" name="title" v-model="data.title">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label error-path="channels">
            Oldalak:
            <channel-selector v-model="data.channels"></channel-selector>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Stratégia:
          </label>
          <input id="strategy-thresholds" type="radio" value="thresholds" v-model="data.strategy"><label for="strategy-thresholds">Határértékek</label>
          <input id="strategy-top" type="radio" value="top" v-model="data.strategy"><label for="strategy-top">Top N</label>
          <span error-path="strategy"></span>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Referencia időpont:
            <div class="input-group">
              <span class="input-group-label">-</span>
              <input class="input-group-field" type="number" name="readTimeOffsetInDays" min="0" v-model="data.readTimeOffsetInDays">
              <span class="input-group-label">nap</span>
            </div>
            <label error-path="readTimeOffsetInDays"></label>
          </label>
        </div>
        <div class="small-4 medium-2 end columns">
          <label>
            Visszamenőleg:
            <div class="input-group">
              <input class="input-group-field" type="number" name="topHours" v-model="data.topHours">
              <span class="input-group-label">óra</span>
            </div>
            <label error-path="topHours"></label>
          </label>
        </div>
      </div>

      <div class="row expanded" v-if="data.strategy === 'top'">
        <div class="small-4 medium-2 columns">
          <label>
            Top N:
            <div class="input-group">
              <input class="input-group-field" type="number" name="topCount" v-model="data.topCount">
              <span class="input-group-label">db.</span>
            </div>
            <label error-path="topCount"></label>
          </label>
        </div>
        <div class="small-4 medium-2 columns">
          <label>
            Szempont:
            <select name="topOrder" v-model="data.topOrder">
              <option value="">-</option>
              <option value="like">Like</option>
              <option value="share">Share</option>
              <option value="comment">Comment</option>
              <option value="reach">Reach</option>
              <option value="click">Click</option>
            </select>
          </label>
        </div>
        <div class="small-4 medium-2 end columns">
          <label>
            Időpont:
            <input type="time" name="topTime" v-model="data.topTime">
          </label>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Poszt típusok:
          </label>
          <input id="post-type-status" type="checkbox" value="status" v-model="data.postTypes"><label for="post-type-status">Státusz</label>
          <input id="post-type-link" type="checkbox" value="link" v-model="data.postTypes"><label for="post-type-link">Link</label>
          <input id="post-type-photo" type="checkbox" value="photo" v-model="data.postTypes"><label for="post-type-photo">Kép</label>
          <input id="post-type-video" type="checkbox" value="video" v-model="data.postTypes"><label for="post-type-video">Videó</label>
          <span error-path="postTypes"></span>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Like:
            <input type="text" name="thresholdLike" v-model="data.thresholdLike">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Share:
            <input type="text" name="thresholdShare" v-model="data.thresholdShare">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Comment:
            <input type="text" name="thresholdComment" v-model="data.thresholdComment">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Reach:
            <input type="text" name="thresholdReach" v-model="data.thresholdReach">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Click:
            <input type="text" name="thresholdClick" v-model="data.thresholdClick">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-4 medium-2 columns">
          <label>
            Max. elemszám:
            <input type="text" name="maxItemNum" v-model="data.maxItemNum">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Hivatkozások:
          </label>
          <input id="use-links-link" type="radio" value="link" v-model="data.useLinks"><label for="use-links-link">Eredeti hivatkozások</label>
          <input id="use-links-permalink" type="radio" value="permalink" v-model="data.useLinks"><label for="use-links-permalink">Facebook hivatkozások</label>
          <span error-path="useLinks"></span>
        </div>
      </div>

      <div class="row expanded" v-if="data.useLinks === 'permalink'">
        <div class="small-12 columns">
          <label>
            Beszédes hivatkozások használata:
            <input id="usePrettyLinks" type="checkbox" v-model="data.usePrettyLinks">
          </label>
          <p class="help-text">https://www.facebook.com/132535353/posts/1368792145283210 <b>helyett</b> https://www.facebook.com/oldalnev/posts/1368792145283210</p>
          <span error-path="usePrettyLinks"></span>
        </div>
      </div>

      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Tartalom:
          </label>
          <input id="use-feed-contents" type="radio" value="feed" v-model="data.useContents"><label for="use-feed-contents">Feedben szereplő</label>
          <input id="use-remote-contents" type="radio" value="remote" v-model="data.useContents"><label for="use-remote-contents">Távoli tartalom</label>
          <span error-path="useContents"></span>
        </div>
      </div>

      <div class="row expanded" v-if="data.useLinks === 'link'">
        <div class="small-12 medium-4 columns">
          <label>
            Átadott paraméterek:
            <input type="text" name="passedParams" v-model="data.passedParams">
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 columns">
          <label>
            Hirstop használata:
            <input id="rewriteUrl" type="checkbox" v-model="data.rewriteUrl">
          </label>
          <span error-path="rewriteUrl"></span>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Az eredeti hivatkozás tartalmazza:
            <textarea v-model="data.filterLink"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            Az eredeti hivatkozás NEM tartalmazza:
            <textarea v-model="data.filterLinkNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            A Facebook link tartalmazza:
            <textarea v-model="data.filterPermaLink"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            A Facebook link NEM tartalmazza:
            <textarea v-model="data.filterPermaLinkNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Az üzenet tartalmazza:
            <textarea v-model="data.filterMessage"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            Az üzenet NEM tartalmazza:
            <textarea v-model="data.filterMessageNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            A "page title" mező tartalmazza:
            <textarea v-model="data.filterMetaTitle"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            A "page title" mező NEM tartalmazza:
            <textarea v-model="data.filterMetaTitleNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            A "meta description" mező tartalmazza:
            <textarea v-model="data.filterMetaDescription"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            A "meta description" mező NEM tartalmazza:
            <textarea v-model="data.filterMetaDescriptionNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Az "OG title" mező tartalmazza:
            <textarea v-model="data.filterOgTitle"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            Az "OG title" mező NEM tartalmazza:
            <textarea v-model="data.filterOgTitleNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Az "OG description" mező tartalmazza:
            <textarea v-model="data.filterOgDescription"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            Az "OG description" mező NEM tartalmazza:
            <textarea v-model="data.filterOgDescriptionNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded">
        <div class="small-12 medium-4 columns">
          <label>
            Az "Author" mező tartalmazza:
            <textarea v-model="data.filterCustomAuthor"></textarea>
          </label>
        </div>
        <div class="small-12 medium-4 end columns">
          <label>
            Az "Author" mező NEM tartalmazza:
            <textarea v-model="data.filterCustomAuthorNot"></textarea>
          </label>
        </div>
      </div>
      <div class="row expanded bottom">
        <div class="small-4 columns">
          <button type="submit" class="button primary trans-uppercase">Mentés</button>
          <button type="button" class="button alert trans-uppercase" v-if="data.id" @click="remove">Törlés</button>
          <button type="button" class="button secondary trans-uppercase" @click="back">Vissza</button>
        </div>
      </div>
    </joi-form>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import * as mutationTypes from '../../store/mutation-types'
import JoiForm from '../../inputs/joi-form'
import ChannelSelector from '../../inputs/channel-selector'
import {editFeed as validationSchema} from '../../../schemas'
import feedService from '../../services/feed'
import i18nService from '../../services/i18n'
import Confirm from '../../mixins/Confirm'
import $ from 'jquery'
import autosize from 'autosize'

export default {
  name: 'feeds-edit',
  mixins: [Confirm],
  components: {
    JoiForm,
    ChannelSelector
  },
  data () {
    return {
      data: {
        id: undefined,
        title: undefined,
        strategy: undefined,
        channels: [],
        topCount: undefined,
        topOrder: undefined,
        topTime: undefined,
        topHours: undefined,
        readTimeOffsetInDays: undefined,
        thresholdLike: undefined,
        thresholdShare: undefined,
        thresholdComment: undefined,
        thresholdReach: undefined,
        thresholdClick: undefined,
        postTypes: [],
        maxItemNum: undefined,
        useLinks: undefined,
        usePrettyLinks: undefined,
        useContents: undefined,
        passedParams: undefined,
        rewriteUrl: undefined,
        filterLink: undefined,
        filterLinkNot: undefined,
        filterPermaLink: undefined,
        filterPermaLinkNot: undefined,
        filterMessage: undefined,
        filterMessageNot: undefined,
        filterMetaTitle: undefined,
        filterMetaTitleNot: undefined,
        filterMetaDescription: undefined,
        filterMetaDescriptionNot: undefined,
        filterOgTitle: undefined,
        filterOgTitleNot: undefined,
        filterOgDescription: undefined,
        filterOgDescriptionNot: undefined,
        filterCustomAuthor: undefined,
        filterCustomAuthorNot: undefined
      },
      validationSchema,
      formError: null,
      existingUser: false,
      lastReadingInf: null
    }
  },
  created: function () {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
  },
  mounted: function () {
    autosize($('textarea', this.$el))
  },
  watch: {
    '$route': function (newVal, oldVal) {
      if (newVal.params.id) {
        this.load(newVal.params.id)
      }
    }
  },
  methods: {
    ...mapMutations([mutationTypes.BUSY_ON, mutationTypes.BUSY_OFF]),
    onAddNewItem () {
      this.$router.push('feeds/edit')
    },
    back () {
      this.$router.push({name: 'feed-list'})
    },
    load (id) {
      this.reset()
      this[mutationTypes.BUSY_ON]()
      feedService.load(id).then((data) => {
        this[mutationTypes.BUSY_OFF]()
        this.data = data
        this.lastReadingInf = i18nService.interval(data.readStartedAt, data.readEndedAt)
        this.existingUser = Boolean(data.masterEmail)
        window.setTimeout(() => {
          autosize.update($('textarea', this.$el))
        }, 0)
      })
      .catch(() => {
        this[mutationTypes.BUSY_OFF]()
      })
    },
    reset () {
    },
    save (formData) {
      this[mutationTypes.BUSY_ON]()
      feedService.save(this.data.id, formData).then((result) => {
        this[mutationTypes.BUSY_OFF]()
        this.back()
      }).catch((err) => {
        this[mutationTypes.BUSY_OFF]()
        this.formError = err
      })
    },
    remove () {
      this.confirm('Törlés', 'Biztos vagy benne?').then((confirmed) => {
        if (confirmed) {
          this[mutationTypes.BUSY_ON]()
          feedService.remove(this.data.id).then((result) => {
            this[mutationTypes.BUSY_OFF]()
            this.back()
          }).catch((err) => {
            this[mutationTypes.BUSY_OFF]()
            this.formError = err
          })
        }
      })
    },
    download () {
      if (this.data.id) {
        feedService.download(this.data.id)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../../../sass/foundation-import';
  @import '../../../sass/layouts/form';
</style>



// WEBPACK FOOTER //
// Edit.vue?75127db6